import { AxiosAdapter as CoreAxiosAdapter } from '@core/adapters';
import { ERROR_MESSAGES, ROUTE_NAME } from '@infra/constants';

export class AxiosAdapter extends CoreAxiosAdapter {
  async handle400Error(errorMessage: string, errorCode: string) {
    const alertStore = this.getAlertStore();
    const router = this.getRouter();

    switch (errorCode) {
      case 'NO_PASSWORD': {
        throw errorCode;
      }
      case 'NOT_ON_SALE': {
        await alertStore.showAlertDialog(
          ERROR_MESSAGES[errorCode as keyof typeof ERROR_MESSAGES]
        );
        break;
      }
      case 'NOT_FOUND_TICKET': {
        await alertStore.showAlertDialog(
          ERROR_MESSAGES[errorCode as keyof typeof ERROR_MESSAGES]
        );
        await router.push({ name: ROUTE_NAME.Main });
        break;
      }
      default: {
        await alertStore.showAlertDialog(errorMessage);
      }
    }
  }
}
